
<template>
  <div class="scope-select">
    <el-select
      ref="elSelect"
      :key="language"
      v-model="content"
      filterable
      size="small"
      :multiple="isMultiple"
      reserve-keyword
      :placeholder="placeholderValue"
      clearable
      v-bind="$attrs"
      :filter-method="filterMethod"
      :remote="isRemote"
      :remote-method="remoteMethod"
      :loading="loading"
      v-on="$listeners"
      @change="change"
      @focus="handleFocus"
    >
      <el-option
        v-for="scope in filteredScopeList"
        :key="scope.id"
        :label="getOptionLabel(scope)"
        :value="scope.id"
      />
    </el-select>
    <el-button v-if="multipleSelectAll" style="vertical-align: top;" type="primary" @click="onClickAll">{{ $t('riskMonitoring.select_all') }}</el-button>
  </div>
</template>

<script>
import { fetchMchScopeAllList } from '@/api/kyc/kyc'
export default {
  name: 'Scope_Select',
  model: {
    prop: 'value',
    event: 'updateValue'
  },
  props: {
    isMultiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array],
      default: ''
    },
    httpRequestMethod: {
      type: Function,
      default: fetchMchScopeAllList
    },
    selectPlaceholder: {
      type: String,
      default: ''
    },
    multipleSelectAll: {
      type: Boolean,
      default: false
    },
    isWalletMcc: {
      type: Boolean,
      default: false
    },
    isRemote: {
      type: Boolean,
      default: false
    },
    remoteParams: {
      type: Function,
      default: keyword => ({ businessName: keyword, current: 1, size: 20 })
    },
    optionLabel: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      scopeAllList: [],
      filteredScopeList: [],
      loading: false,
      content: this.value,
      hasLoadedAllData: false,
      hasLoadedRemote: false
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    placeholderValue() {
      const kycPlaceholder = this.$t('kyc.placeholder_enter_mcc')
      return this.selectPlaceholder ? this.selectPlaceholder : (kycPlaceholder)
    }

  },
  watch: {
    value(newVal) {
      this.content = this.value
      /* if (!Array.isArray(newVal) && !this.loading) { // 如果有值传入且搜索接口没有调用则调用一次远程搜索接口
        this.remoteMethod(newVal)
      }*/
    }
  },
  mounted() {
    if (!this.isRemote) this.loadAllData()
  },
  methods: {
    loadAllData() {
      if (this.isRemote || this.hasLoadedAllData) return

      this.loading = true
      this.httpRequestMethod('all').then(response => {
        const scopes = response.data || []
        // Normalize different backend shapes into the fields used by this component.
        this.scopeAllList = scopes.map(scope => {
          const id = scope.id || scope.scope_code || scope.code || scope.scopeCode || ''
          const code = scope.scope_code
          const all_scope_cn_name = scope.scope_cn_name
          const all_scope_en_name = scope.scope_en_name
          return {
            ...scope,
            id,
            code,
            all_scope_cn_name,
            all_scope_en_name
          }
        })
        this.filteredScopeList = [...this.scopeAllList]
        this.hasLoadedAllData = true
      }).finally(() => {
        this.loading = false
      })
    },
    filterMethod(val) {
      if (this.isRemote) return
      if (!val) {
        this.filteredScopeList = [...this.scopeAllList]
        return
      }

      const searchTerm = val.toLowerCase()
      this.filteredScopeList = this.scopeAllList.filter(scope => {
        const code = scope.code ? String(scope.code).toLowerCase() : ''
        const cnName = scope.all_scope_cn_name ? scope.all_scope_cn_name.toLowerCase() : ''
        const enName = scope.all_scope_en_name ? scope.all_scope_en_name.toLowerCase() : ''
        return code.includes(searchTerm) || cnName.includes(searchTerm) || enName.includes(searchTerm)
      })
    },
    remoteMethod(val) {
      if (!this.isRemote) {
        this.filterMethod(val)
        return
      }
      this.loading = true
      this.httpRequestMethod(this.remoteParams(val)).then(res => {
        const data = res.data || {}
        const list = data.list || data || []
        this.filteredScopeList = list.map(item => ({
          ...item,
          id: item.business_id || item.franchisee_id || item.id || item.business_no || item.franchisee_no || item.businessNo || item.franchiseeNo
        }))
      }).finally(() => {
        this.loading = false
      })
    },
    getOptionLabel(scope) {
      if (this.optionLabel) return this.optionLabel(scope)
      return (scope.code ? scope.code + ' ' : '') + (this.language === 'zh' ? scope.all_scope_cn_name : scope.all_scope_en_name)
    },
    change(val) {
      // 如果清空了，确保下拉列表恢复显示
      if (val === '' || val === null || val === undefined) {
        if (this.isRemote) {
          this.filteredScopeList = []
          this.hasLoadedRemote = false
        } else {
          this.filteredScopeList = [...this.scopeAllList]
        }
      }
      this.$emit('updateValue', val)
      if (this.isMultiple) {
        this.handleBlur()
      }
    },
    handleFocus() {
      // 确保数据已加载
      if (!this.hasLoadedAllData) {
        this.loadAllData()
      }
      // 远程模式：首次聚焦时自动搜索空关键字，让用户点击即看到结果
      if (this.isRemote && !this.hasLoadedRemote) {
        this.remoteMethod('')
        this.hasLoadedRemote = true
      }
    },
    handleBlur() {
      setTimeout(() => {
        this.$refs.elSelect.blur() // 调用原生元素的 blur 方法
      }, 0)
    },
    onClickAll() {
      this.content = this.scopeAllList.map(item => item.id)
      this.change(this.content)
    }
  }
}
</script>
<style scoped>
.scope-select,
.scope-select .el-select {
  width: 100%;
}
.select-scope-default{
  width: 230px;
  margin: 0 10px 24px 0;
}
.search-english{
  width: 400px;
}
</style>

